import * as React from "react"
import { Flex, useBreakpointValue } from "@chakra-ui/react"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import { HomePage, InfoPage, PublicKeysPage, TokenSwap, LoginPage } from "./pages"
import Sidebar from "./components/Sidebar" // Import the Sidebar component
import TopBar from "./components/TopBar" // Import the TopBar component
import { AppProvider } from "./AppContext"

const PrivateRoute: React.FC<{ route: React.ReactElement }> = ({ route }): React.ReactElement => {
  const token = localStorage.getItem("token") // Check for JWT token

  if (token) {
    return route
  } else {
    return <Navigate to={"/login"} />
  }
}

export const App = () => {
  const isDesktop = useBreakpointValue({ base: false, md: true }, { ssr: false }) // Display sidebar on md and larger screens

  return (
    <AppProvider>
      <Router>
        <Flex flexDirection={isDesktop ? "row" : "column"}>
          {/* Only show Sidebar and TopBar if not on the Login page */}
          <Routes>
            <Route path="/login" element={null} /> {/* Placeholder for Login route */}
            <Route path="*" element={isDesktop ? <Sidebar /> : <TopBar />} />
          </Routes>

          <Flex as="main" flex="1" direction="column" align="flex-start" justify="flex-start">
            <Routes>
              <Route path="/" element={<PrivateRoute route={<HomePage />} />} />
              <Route path="/info" element={<PrivateRoute route={<InfoPage />} />} />
              <Route path="/publicKeys" element={<PrivateRoute route={<PublicKeysPage />} />} />
              <Route path="/swap" element={<PrivateRoute route={<TokenSwap />} />} />
              <Route path="/login" element={<LoginPage />} /> {/* Add the LoginPage route */}
            </Routes>
          </Flex>
        </Flex>
      </Router>
    </AppProvider>
  )
}
